module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-14-LUGLIO-6392d75b15e2fa3bdc2d26510b4acb11.jpg";